import classNames from "classnames";
import * as React from "react";
import IconSearch from "ReactComponents/Shared/Icons/icon-search";

interface IInlineSearchProps {
    Placeholder: string;
    className?: string;
    open?: boolean;
    searchUrl?: string;
}

export const InlineSearch = React.forwardRef(
    (props: IInlineSearchProps, ref: React.ForwardedRef<HTMLInputElement>) => {
        const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
            if (
                e.key === "Enter" &&
                props.searchUrl &&
                typeof window !== "undefined" &&
                !window.cludo_engineId
            ) {
                window.location.href = `${props.searchUrl}?q=${encodeURIComponent(e.currentTarget.value)}`;
            }
        };

        return (
            <div className={classNames("inline-search content-module", props.className)}>
                <div className="content-row">
                    <div className="inline-search__input-wrapper">
                        <IconSearch />
                        <label htmlFor="inline-search" className="sr-only">
                            Søg
                        </label>
                        <input
                            id="inline-search"
                            ref={ref}
                            disabled={!props.open}
                            name="searchrequest"
                            className="inline-search__input"
                            type="search"
                            role="searchbox"
                            placeholder={props.Placeholder}
                            aria-autocomplete="list"
                            aria-haspopup="true"
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>
            </div>
        );
    }
);
